// Lista de países por idioma de la UI. Extraída de ApplicantModal.js para
// compartirla con el módulo ERP (ficha de colaborador) — una sola fuente
// de verdad. El valor guardado es el nombre del país en el idioma activo,
// igual que en postulantes y en el portal de candidatos (candidate.country).
export const COUNTRIES_BY_LANGUAGE = {
  es: [
      "Afganistán", "Albania", "Alemania", "Andorra", "Angola", "Antigua y Barbuda",
      "Arabia Saudita", "Argelia", "Argentina", "Armenia", "Australia", "Austria",
      "Azerbaiyán", "Bahamas", "Bangladés", "Barbados", "Baréin", "Bélgica",
      "Belice", "Benín", "Bielorrusia", "Bolivia", "Bosnia y Herzegovina", "Botsuana",
      "Brasil", "Brunéi", "Bulgaria", "Burkina Faso", "Burundi", "Bután",
      "Cabo Verde", "Camboya", "Camerún", "Canadá", "Catar", "Chad",
      "Chile", "China", "Chipre", "Colombia", "Comoras", "Congo",
      "Corea del Norte", "Corea del Sur", "Costa de Marfil", "Costa Rica", "Croacia", "Cuba",
      "Dinamarca", "Dominica", "Ecuador", "Egipto", "El Salvador", "Emiratos Árabes Unidos",
      "Eritrea", "Eslovaquia", "Eslovenia", "España", "Estados Unidos", "Estonia",
      "Etiopía", "Filipinas", "Finlandia", "Fiyi", "Francia", "Gabón",
      "Gambia", "Georgia", "Ghana", "Granada", "Grecia", "Guatemala",
      "Guinea", "Guinea-Bisáu", "Guinea Ecuatorial", "Guyana", "Haití", "Honduras",
      "Hungría", "India", "Indonesia", "Irak", "Irán", "Irlanda",
      "Islandia", "Islas Marshall", "Islas Salomón", "Israel", "Italia", "Jamaica",
      "Japón", "Jordania", "Kazajistán", "Kenia", "Kirguistán", "Kiribati",
      "Kuwait", "Laos", "Lesoto", "Letonia", "Líbano", "Liberia",
      "Libia", "Liechtenstein", "Lituania", "Luxemburgo", "Madagascar", "Malasia",
      "Malaui", "Maldivas", "Malí", "Malta", "Marruecos", "Mauricio",
      "Mauritania", "México", "Micronesia", "Moldavia", "Mónaco", "Mongolia",
      "Montenegro", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal",
      "Nicaragua", "Níger", "Nigeria", "Noruega", "Nueva Zelanda", "Omán",
      "Países Bajos", "Pakistán", "Palaos", "Panamá", "Papúa Nueva Guinea", "Paraguay",
      "Perú", "Polonia", "Portugal", "Reino Unido", "República Centroafricana", "República Checa",
      "República del Congo", "República Democrática del Congo", "República Dominicana", "Ruanda", "Rumania", "Rusia",
      "Samoa", "San Cristóbal y Nieves", "San Marino", "San Vicente y las Granadinas", "Santa Lucía", "Santo Tomé y Príncipe",
      "Senegal", "Serbia", "Seychelles", "Sierra Leona", "Singapur", "Siria",
      "Somalia", "Sri Lanka", "Suazilandia", "Sudáfrica", "Sudán", "Sudán del Sur",
      "Suecia", "Suiza", "Surinam", "Tailandia", "Tanzania", "Tayikistán",
      "Timor Oriental", "Togo", "Tonga", "Trinidad y Tobago", "Túnez", "Turkmenistán",
      "Turquía", "Tuvalu", "Ucrania", "Uganda", "Uruguay", "Uzbekistán",
      "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Yibuti", "Zambia",
      "Zimbabue",
  ],
  en: [
      "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
      "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas",
      "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize",
      "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil",
      "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
      "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China",
      "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba",
      "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
      "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
      "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon",
      "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
      "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
      "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq",
      "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan",
      "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
      "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein",
      "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives",
      "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico",
      "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
      "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
      "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia",
      "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama",
      "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
      "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
      "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal",
      "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
      "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain",
      "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
      "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo",
      "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
      "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
      "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen",
      "Zambia", "Zimbabwe",
  ],
};

export default COUNTRIES_BY_LANGUAGE;
